// extracted by mini-css-extract-plugin
export var bounce = "_jv-1";
export var generatingText = "_jv-6";
export var lightning = "_jv-4";
export var popup = "_jv-5";
export var progressBar = "_jv-7";
export var progressFill = "_jv-8";
export var progressShimmer = "_jv-9";
export var progressText = "_jv-a";
export var shimmer = "_jv-3";
export var uploadIcon = "_jv-0";
export var uploadingText = "_jv-2";